// import {} from '../types';

export default (state, action) => {
	const { payload, type } = action;

	switch (type) {
		case 'GET_ORDERS':
			return {
				...state,
				orders: payload,
			};
		case 'TOOGLE_NEW_ORDER_DIALOG':
			return {
				...state,
				openNewOrderDialog: payload,
			};
		case 'TOOGLE_IS_LOADING':
			return {
				...state,
				isLoading: payload,
			};
		case 'TOOGLE_TOAST_ALERT':
			return {
				...state,
				toastAlert: payload,
			};
		case 'SET_CURRENT_ORDER_ID':
			return {
				...state,
				currentOrderId: payload,
			};
		case 'SET_FILTER_OPTION':
			return {
				...state,
				filterOption: payload,
			};
		case 'SET_FILTER_ORDER_NAV':
			return {
				...state,
				filterOrderNav: payload,
			};

		default:
			return state;
	}
};
